import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'lib-whitelist-character-error',
  templateUrl: './whitelist-character-error.component.html',
  styleUrls: ['./whitelist-character-error.component.scss']
})
export class WhitelistCharacterErrorComponent {

  @Input()
  whitelistFormControl: FormControl;
}
